function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var PreferredPlacements = {
    auto: 'auto',
    top: 'top',
    topStart: 'top-start',
    topEnd: 'top-end',
    end: 'end',
    endTop: 'end-top',
    endBottom: 'end-bottom',
    bottom: 'bottom',
    bottomStart: 'bottom-start',
    bottomEnd: 'bottom-end',
    start: 'start',
    startTop: 'start-top',
    startBottom: 'start-bottom'
};
export var AllPlacements = _objectSpread({}, PreferredPlacements, {
    right: 'right',
    rightStart: 'right-start',
    rightEnd: 'right-end',
    left: 'left',
    leftStart: 'left-start',
    leftEnd: 'left-end'
});
export var Placements = PreferredPlacements;
export default Placements;
